import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { DashboardContainer } from '../../dashboard.container';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { SocialAuthService } from 'angularx-social-login';


@Component({
    selector: 'app-user-settings',
    templateUrl: 'settings.component.html',
    styleUrls: ['../../dashboard.component.css', './settings.component.scss']
})

export class SettingsComponent implements OnInit {

    settingsForm: FormGroup;
    submitted = false;
    passwordMatches = true;
    selectedFile: File;
    displayedName;
    logo;
    userInfo = {
        profileImage: '',
        firstName: '',
        lastName: '',
        displayName: '',
        country: '',
        phone: '',
        email: '',
        emailVerified: false,
        password: '',
        repeatedPassword: '',
        phonePrefix: ''
    };

    swal: any = Swal;

    countries = ['-', 'Afghanistan', 'Åland Islands', 'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla',
        'Antarctica', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas',
        'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan',
        'Bolivia, Plurinational State of', 'State of Bonaire Sint Eustatius and Saba', 'Bosnia and Herzegovina',
        'Botswana', 'Bouvet Island', 'Brazil', 'British Indian Ocean Territory', 'Brunei Darussalam', 'Bulgaria', 'Burkina',
        'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Central African Republic Central', 'Chad',
        'Chile', 'China', 'Christmas', 'Cocos (Keeling) Islands', 'Colombia', 'Comoros', 'Congo', 'Congo,', 'Cook', 'Costa', 'Côte',
        'Croatia', 'Cuba', 'Curaçao', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica Dominica', 'Dominican Republic',
        'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Falkland', 'Faroe Islands',
        'Fiji', 'Finland', 'France', 'French', 'French', 'French', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar',
        'Greece', 'Greenland', 'Grenada', 'Guadeloupe', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea-Bissau', 'Guyana',
        'Haiti', 'Heard Island and McDonald Islands', 'Holy See (Vatican City State)', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland',
        'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan',
        'Kazakhstan', 'Kenya', 'Kiribati', 'Korea,', 'Korea,', 'Kuwait', 'Kyrgyzstan', 'Lao', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia',
        'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macao', 'Macedonia,', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives',
        'Mali', 'Malta', 'Marshall', 'Martinique', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Micronesia', 'Moldova', 'Monaco',
        'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands',
        'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'Northern', 'Norway', 'Oman',
        'Pakistan', 'Palau', 'Palestinian', 'Panama', 'Papua', 'Paraguay', 'Peru', 'Philippines', 'Pitcairn', 'Poland', 'Portugal',
        'Puerto Rico', 'Qatar', 'Réunion', 'Romania', 'Russian Federation', 'Rwanda', 'Saint Barthélemy', 'Saint Helena,',
        'Saint Kitts', 'Saint Lucia', 'Saint Martin', 'Saint Pierre', 'Saint Vincent', 'Samoa', 'San Marino', 'Sao Tome',
        'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Sint Maarten(Dutch part)',
        'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Georgia', 'South Sudan', 'Spain',
        'Sri Lanka', 'Sudan', 'Suriname', 'Svalbard and Jan Mayen', 'Swaziland', 'Sweden', 'Switzerland', 'Syrian',
        'Taiwan, Province of China', 'Tajikistan', 'Tanzania,', 'Thailand', 'Timor-Leste', 'Togo', 'Tokelau', 'Tonga',
        'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks and Caicos Islands', 'Tuvalu', 'Uganda',
        'Ukraine', 'United ArabEmirates', 'United Kingdom', 'United States', 'United States Minor Outlying Islands',
        'Uruguay', 'Uzbekistan', 'Vanuatu', 'Venezuela,', 'Viet', 'Virgin Islands, British', 'Virgin Islands, U.S. ',
        'Wallis and Futuna', 'Western Sahara', 'Yemen', 'Zambia', 'Zimbabwe'];

    constructor(private formBuilder: FormBuilder, private dashboardContainer: DashboardContainer,
                protected router: Router, private socialAuth: SocialAuthService) { }

    // convenience getter for easy access to form fields
    get f() { return this.settingsForm.controls; }

    ngOnInit() {
        this.dashboardContainer.changeHeader();
        // this.dashboardContainer.enableSpinner(true);
        this.settingsForm = new FormGroup({
            firstName: new FormControl('', Validators.required),
            lastName: new FormControl('', Validators.required),
            displayName: new FormControl('', Validators.required),
            country: new FormControl(''),
            profileImage: new FormControl(''),
            phone: new FormControl('',
                Validators.compose(
                    [Validators.minLength(10), Validators.maxLength(10), Validators.pattern('[0-9]+')]
                )),
            phonePrefix: new FormControl(
                Validators.compose(
                    [Validators.minLength(3), Validators.maxLength(3)]
                )),
            email: new FormControl('', Validators.email),
            password: new FormControl('', Validators.minLength(8)),
            repeatedPassword: new FormControl('', Validators.minLength(8)),
        });

        this.dashboardContainer.getUserInfo().subscribe(userInfo => {
            let img = '';
            if (userInfo.photo === null || userInfo.photo === null) {
                img = '../../../assets/img/unknown_quotes.jpg';
            } else {
                img = 'data:image/jpeg;base64,' + userInfo.photo;
            }
            let userPhone = '';
            let phonePrefix = '';
            if (userInfo.phone !== null) {
                if (userInfo.phone.length > 10) {
                    userPhone = userInfo.phone.substring(userInfo.phone.length - 10);
                    phonePrefix = userInfo.phone.substring(0, 3);
                } else {
                    userPhone = userInfo.phone;
                }
            }
            this.userInfo = {
                profileImage: img,
                firstName: userInfo.name,
                lastName: userInfo.surname,
                displayName: userInfo.screenName !== null ? userInfo.screenName : '',
                country: userInfo.country !== null ? userInfo.country : '',
                phone: userPhone,
                email: userInfo.email,
                emailVerified: userInfo.emailConfirmed === null ? false : true,
                password: '',
                repeatedPassword: '',
                phonePrefix: phonePrefix
            };
            this.displayedName = userInfo.name;
            // this.dashboardContainer.enableSpinner(false);
        });

    }

    goBack() {
        window.history.back();
    }

    checkPasswords() {
        if (String(this.settingsForm.controls.password.value.trim()) === String(this.settingsForm.controls.repeatedPassword.value.trim())) {
            this.passwordMatches = true;
        } else {
            this.passwordMatches = false;
        }
    }


    onFileChanged(event) {
        this.selectedFile = event.target.files[0];
        this.logo = this.selectedFile;

        const reader = new FileReader();

        reader.onload = (e: any) => {
            this.logo = e.target.result;
        };
        reader.readAsDataURL(this.selectedFile);
    }

    onSubmit() {

        /* if (!this.settingsForm.controls.password.value || !this.settingsForm.controls.repeatedPassword.value) {
            this.swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Please fill the required password fields to continue saving!'
            });
            return;
        } */
        if (!this.passwordMatches) {
            this.swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Passwords do not match!'
            });
            return;
        }
        const userCopy: UserSetting = {

            screenName: this.settingsForm.controls.displayName.value,
            name: this.settingsForm.controls.firstName.value,
            surname: this.settingsForm.controls.lastName.value,
            country: this.userInfo.country,
            phone: this.settingsForm.controls.phone.value,
            email: this.settingsForm.controls.email.value,
            photo: this.logo ? this.logo.split(',')[1]
                : this.userInfo.profileImage.split(',')[1]
        };
        if (this.settingsForm.controls.password.value !== '') {
            userCopy.passwd = this.settingsForm.controls.password.value;
        }
        this.dashboardContainer.changeUserInformation(userCopy);
        this.swal.fire({
            icon: 'success',
            text: 'Successfully saved user data',
            showConfirmButton: false,
            timer: 1500
        });
    }

    sendUserEmailConfirm() {
        this.dashboardContainer.sendUserEmailConfirm(this.dashboardContainer.getUserId());
        Swal.fire('Success', 'Please check your mail', 'success');
    }

    logoutUser() {
        localStorage.removeItem('user');
        this.socialAuth.signOut(true);
        this.router.navigate(['/']);
        setTimeout(() => {
            window.location.reload();
        }, 500);
    }


}

interface UserSetting {
    screenName;
    name;
    surname;
    country;
    phone;
    email;
    passwd?;
    photo;
}
